import { Component, Input } from "@angular/core";

interface FeatureItem {
  image: string;
  title: string;
  description: string;
}

@Component({
  selector: "app-uper-image-card",
  templateUrl: "./uper-image-card.component.html",
  styleUrls: ["./uper-image-card.component.scss"],
})
export class UperImageCardComponent {
  @Input() items: FeatureItem[] = [];

  getItemClass(index: number): string {
    const itemsPerRow = 3;
    const totalItems = this.items.length;
    const itemsInLastRow = totalItems % itemsPerRow;

    // If the item is not in the last row → always 33.33%
    if (index < totalItems - itemsInLastRow) {
      return "col-12 col-md-4";
    }

    // Handle the last row
    if (itemsInLastRow === 1 || itemsInLastRow === 2) {
      return "col-12 col-md-6"; // 50% width
    } else {
      return "col-12 col-md-4"; // Full row, default case
    }
  }
}
